import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private userSource = new BehaviorSubject<any>(null);
  private printStatus = new BehaviorSubject<any>(null);
  private headerMenuSource = new BehaviorSubject<any>(null);

  getPrintCount = this.userSource.asObservable();
  getPrintAdminStatus = this.printStatus.asObservable();
  getHeaderMenuUpdate = this.headerMenuSource.asObservable();

  updateBillPrintCount(user: any) {
    this.userSource.next(user);
  }
  updatePrintAdminStatus(isPrintAdmin: any) {
    this.printStatus.next(isPrintAdmin);
  }
  updateHeaderMenu(menu: any) {
    this.headerMenuSource.next(menu);
  }
}
